import Lenis from 'lenis';
import { gsap } from '../gsap-3.13.0.min';
import { ScrollTrigger } from '../ScrollTrigger.min';

/**
 * Lenis を無効化する（＝ネイティブのホイールスクロールに任せる）要素のセレクタ。
 * 内側にスクロール領域を持つUIはここに追加する。
 * 個別に効かせたい場合は HTML 側に data-lenis-prevent を付ければLenisが自動で判定する。
 */
const PREVENT_SELECTOR = '.c-scrollbox';

export default {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });

    const lenis = new Lenis({
      duration: 1.1,
      wheelMultiplier: 1.0,
      smoothTouch: true,
      // スクロール枠の上ではLenisがwheelをpreventDefaultしないようにする
      prevent: (node) => node instanceof Element && node.matches(PREVENT_SELECTOR),
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    lenis.on('scroll', () => {
      ScrollTrigger.update();
    });

    ScrollTrigger.scrollerProxy(document.documentElement, {
      scrollTop(value) {
        if (arguments.length) lenis.scrollTo(value, { immediate: true });
        else return window.scrollY || document.documentElement.scrollTop;
      },
      getBoundingClientRect() {
        return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
      },
    });
    ScrollTrigger.refresh();
  },
};
